import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {DomSanitizer, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-information-detail',
  templateUrl: './information-detail.component.html',
  styleUrls: ['./information-detail.component.css']
})
export class InformationDetailComponent implements OnInit, AfterViewInit {

  url: any;

  userId: any;
  userName: any;
  fromType: any;

  constructor(private routerInfo: ActivatedRoute, private titleService:Title,
              private sanitizer: DomSanitizer) {
    this.userId = this.routerInfo.snapshot.queryParams['userId'];
    this.userName = this.routerInfo.snapshot.queryParams['userName'];
    this.fromType = this.routerInfo.snapshot.queryParams['fromType'];
    // this.url = this.routerInfo.snapshot.queryParams['url'];
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.routerInfo.snapshot.queryParams['url']);
    //添加title
    this.titleService.setTitle("资讯详情");
  }

  ngOnInit() {
    // $("#ifr").attr("src",this.url);
  }

  ngAfterViewInit() {
    /*let This = this;
    $(function() {


    });
    setTimeout(function () {
      setIframeHeight('ifr');
    },500);
    function setIframeHeight(id){
      try{
        let iframe: any;
        iframe = document.getElementById(id);
        if(iframe.attachEvent){
          (iframe.attachEvent("onload", function(){
            iframe.height =  iframe.contentWindow.document.documentElement.scrollHeight;
          }));
          return;
        }else{
          iframe.onload = function(){
            iframe.height = iframe.contentDocument.body.scrollHeight;
          };
          return;
        }
      }catch(e){
        throw new Error('setIframeHeight Error');
      }
    }*/
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/information-detail/information-detail.component.ts